import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabSamplePot from "../../Assets/Bluelab Sample Pot.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Bluelab_Sample_Pot = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 46,
      name: "Bluelab Sample Pot",
      price: 8484,
      image: BluelabSamplePot,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabSamplePot}
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Bluelab Sample Pot</h2>
            <p className="product-price">₹{8484}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>
                Ensure Accurate Readings and Prolong Probe Life with Our Sample
                Pot
              </h5>
              Achieve precise probe measurements while safeguarding your probes
              from potential damage using our sample pot, designed for
              hassle-free installation with compatible fittings.
              <h5 className="mt-3">Key Features:</h5>
              <ul>
                <li>
                  <span className="fw-bold">Compatibility:</span> Works
                  seamlessly with the Bluelab Intellidose Controller and Bluelab
                  Guardian Monitor Wi-Fi (excluding Inline).
                </li>
                <li>
                  <span className="fw-bold">Easy Installation:</span> Fittings
                  included for straightforward setup.
                </li>
              </ul>
              Protect your investment and enhance your monitoring capabilities
              today!
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_Sample_Pot;
